import script from "./DocMoreMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocMoreMenu.vue?vue&type=script&setup=true&lang=ts"

import "./DocMoreMenu.vue?vue&type=style&index=0&id=b823083a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b823083a"]])

export default __exports__